import React, {useState, useEffect, useRef} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, options_state_new, options_segment, zeroDate, valueToOption} from "../../atom/Apollo_styles";
import {
  accountgroups_path,
  users_path,
  accountgroupedit_path,
  accounteditapollo_path,
  apollo_accountgroup_path
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  AccountGroup,
} from "../../organism/ACCOUNT/AccountModel";
import {DeleteButton} from "../../molecule/Apollo_Button";
import {useHistory, useParams} from "react-router-dom";
import {ApolloContext} from "../../atom/Apollo_Context";
import Typography from '@material-ui/core/Typography';
import {Link} from "react-router-dom";
import Collapse from "@material-ui/core/Collapse/Collapse";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import CardActions from "@material-ui/core/CardActions/CardActions";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR, APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_ADMIN, ApolloUserProfileAuth, IsAuthorization} from "../../atom/Apollo_Authorization";
import Tooltip from '@material-ui/core/Tooltip';
import {ListItem} from "@material-ui/core";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";

import ApolloAccountList from "../../organism/ACCOUNT/Apollo_AccountList";
import ApolloUserList from "../../organism/USER/Apollo_UserList";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_GROUP_DETAIL,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

/*
    画面名：アカウントグループ詳細画面
 */
const AccountGroupDetail: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const {accountgroupid} = useParams<{accountgroupid: string}>();
  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [openaccount, setAccountOpen] = React.useState(false);
  const [openuser, setUserOpen] = React.useState(false);
  const [product, setProduct] = useState<AccountGroup>();
  const processing = useRef(false);
  // 操作前データ
  const beforeData = useRef<any>(null);
  const requestData = useRef<any>(null);
  const resultData = useRef<any>(null);
  const resultApi = useRef(-1);
  const logTime = useRef("");
  const actionType = useRef(0); // 0:参照 1:新規 2:更新 3:削除 4:アップロード

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 9,
    breadId: 3,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }
  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR);

  const products = [
    {
      name: 'アカウントグループID',
      desc: '',
      value: product?.accountgroupId,
      isDisplay: true
    },
    {
      name: 'アカウントグループ名',
      desc: '',
      value: product?.accountgroupName,
      isDisplay: true
    },
    {
      name: '請求リソース',
      desc: '',
      // value: (product?.billingId ? product?.billingId : "")
      //   + ' : ' + (product?.billingName ? product?.billingName : '')
      //   + ' : ' + (product?.creditLimitAmount ? product?.creditLimitAmount.toLocaleString() : ''
      // ),
      value: (product?.billingName ? product?.billingName : ''),
      isDisplay: true
    },
    {
      name: 'カスタムセグメント操作権限',
      desc: '',
      value: product?.customSegmentFlg ? valueToOption(product?.customSegmentFlg, options_segment).label : "",
      isDisplay: isAuthorization
    },
    // {
    //   name: 'ジオセグメント操作権限',
    //   desc: '',
    //   value: product?.geoSegmentFlg ? valueToOption(product?.geoSegmentFlg, options_segment).label : "",
    //   isDisplay: isAuthorization
    // },
    {
      name: 'ステータス',
      desc: '',
      value: product?.status ? valueToOption(product?.status, options_state_new).label : "",
      isDisplay: isAuthorization
    },
    {
      name: '作成日',
      desc: '',
      value: (product?.modifiedAt && product?.createdAt !== zeroDate) ? moment(product?.createdAt).format("YYYY-MM-DD HH:mm") : "",
      isDisplay: isAuthorization
    },
    {
      name: '更新日',
      desc: '',
      value: product?.modifiedAt ? moment(product?.modifiedAt).format("YYYY-MM-DD HH:mm") : "",
      isDisplay: isAuthorization
    },
  ];

  useEffect(() => {
    const url = apollo_accountgroup_path + "/" + accountgroupid;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        if (response.data.result.accountgroupName === undefined) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"E","1"),
            }
          });
        }
        // 操作前データ保存
        beforeData.current = JSON.parse(JSON.stringify(response.data.result));
        setProduct(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"E","0"),
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [accountgroupid]);

  // アカウントグループ削除ハンドラ (AP-322対応により未使用)
  const handleDelete = async () => {
    if (processing.current) return;
    processing.current = true;
    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ(実行)
    resultApi.current = 0;
    // 操作ログアクション(削除)
    actionType.current = 3;
    writeLog();

    // アカウントグループ削除API
    const url = apollo_accountgroup_path + "/" + accountgroupid;
    await ApolloAxios.delete(url).then(response => {
      if (response.data.resultCode === 0) {
        // 操作ログ(成功)
        resultApi.current = 1;
        resultData.current = response.data.current;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"I","0"),
          }
        });
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            current: {
              accountGroupId: response.data.current.accountGroupId,
              accountGroupName: response.data.current.accountGroupName,
              accountId: 0,
              accountName: "",
              trackerId: "",
              campaignId: 0,
              roleAuthorization: response.data.current.roleAuthorization,
              customSegment: response.data.current.customSegment,
              geoSegment: response.data.current.geoSegment,
            },
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          }
        });
        history.push(accountgroups_path);
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
        var errMessage = GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"E","2");
        errMessage += response.data.message && " (" + response.data.message + ")";
        console.log(errMessage);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMessage,
          }
        });
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_DETAIL,"E","2"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
      // 処理終了時にprocessingをfalseにする
      processing.current = false;
    });
  };

  const handelGoback = () => {
    const url = accountgroups_path;
    history.push(url);
  };

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    var key = "";
    var beforeValue = "";
    var afterValue = "";
    switch (actionType.current) {
      case 0: // 参照
        break;
      case 1: // 新規
        break;
      case 2: // 更新
        break;
      case 3: // 削除
        key = "論理削除フラグ";
        beforeValue = "0";
        afterValue = "1";
        break;
      case 4: // アップロード
        break;
      default: // 不明
        key = "不明";
    }
    // 項目リスト
    const itemList: ItemList[] = [];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: 0, // 広告主アカウントID
      accountName: "", // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "アカウントグループ詳細画面", // 操作画面名称 〇〇画面
      category: "アカウントグループ", // 操作対象 キャンペーン / セグメント etc...
      actionType: actionType.current === 0 ? "参照" : actionType.current === 1 ? "作成" : actionType.current === 2 ? "更新" : actionType.current === 3 ? "削除" : actionType.current === 4 ? "アップロード" : "不明", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : state.current.accountGroupId + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "アカウントグループID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  return (
    <GenericTemplate title="">

      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Tooltip title="アカウントグループ編集" placement="top">
          <Fab color="primary" aria-label="edit" className={classes.fab}>
            <Link to={accountgroupedit_path + accountgroupid} className={classes.link}>
              <EditIcon/>
            </Link>
          </Fab>
        </Tooltip>

        {/* <Tooltip title="アカウントグループ削除" placement="top">
          <Fab color="primary" aria-label="del" className={classes.fab}>
            <DeleteButton handleDelete={handleDelete} title="アカウントグループ削除" text={`このアカウントグループを削除しますか？`}/>
          </Fab>
        </Tooltip> */}
      </ApolloUserProfileAuth>

      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3} style={{marginBottom: "5px"}}>
              {products?.map((product, index) => {
                return(
                  product.isDisplay
                  ? <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <Typography>{product.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>{product.value}</Typography>
                    </Grid>
                  </React.Fragment>
                  : null
                )
              })}
            </Grid>
            <Divider/>
            <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px"}}>
              所属広告主アカウント一覧
            </Typography>
            <IconButton aria-label="expand row" size="small" onClick={() => setAccountOpen(!openaccount)}>
              {openaccount ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>
            <Collapse in={openaccount} timeout="auto" unmountOnExit>
              <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
                <Tooltip title="広告主アカウント作成" placement="bottom">
                  <Link to={accounteditapollo_path + accountgroupid + "/0"} className={classes.link}>
                    <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                      <AddIcon/>
                    </Fab>
                  </Link>
                </Tooltip>
              </ApolloUserProfileAuth>
              <ApolloAccountList row={product} seni="de"/>
            </Collapse>
            <ApolloUserProfileAuth role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
            <ListItem>
              <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px"}}>
                所属ユーザー一覧
              </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    history.push(users_path + "?type=ag")
                  }}
                  className={classes.blockMarginL}
                >
                  ユーザー管理
                </Button>
              </ListItem>

              <IconButton aria-label="expand row" size="small" onClick={() => setUserOpen(!openuser)}>
                {openuser ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
              </IconButton>

              {/* ユーザーリスト */}
              <ApolloUserList openuser={openuser}/>
            </ApolloUserProfileAuth>

          </CardContent>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default AccountGroupDetail;
